import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { device } from "../../device";
import { RideUnit } from "../../CreateUnit_Form/ride_unit";
import { RideUnits } from "../../../components/CreateUnit_Form/ride";

const TuluRideExpended = ({
  itemsCount,
  rideColumnItems,
  colorUnit,
  logoImage,
  buildingName,
  isPDF,
  isCarpenter
}) => {
  const roomUnitRef = React.useRef();
  // const [unitScale, setUnitScale] = useState();
  const [items, setItems] = useState({});

  useEffect(() => {
    function reduceItems() {
      const rideItems = {};
      rideColumnItems.forEach((item) => {
        let type;
        if (item.type === "scooter") {
          if (item.items.length > 3) {
            type = "scooterLarge";
          } else {
            type = "scooterSmall";
          }
        }
        if (item.type === "bicycle") {
          if (item.items.length > 2) {
            type = "bicycleLarge";
          } else {
            type = "bicycleSmall";
          }
        }
        if (rideItems[type]) {
          return;
        }
        rideItems[type] = item;
      });
      return rideItems;
    }
    setItems(reduceItems());
    // Mount-once: computes items from the initial rideColumnItems prop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper items={rideColumnItems.length}>
      <div style={{ flex: 1, marginBottom: isPDF && 200 }}>
        {!isCarpenter&&<TextWrapper style={{ padding: isPDF && 0 }}>
          {isPDF && (
            <div
              style={{
                marginLeft: 97,
                fontSize: 40,
                fontWeight: "bold",
                fontFamily: "Lexend",
              }}
            >
              {buildingName} <br />
            </div>
          )}
          <ParaOne
            style={{
              textAlign: isPDF && "left",
              marginLeft: isPDF && 97,
              paddingTop: isPDF && 0,
              fontSize: isPDF && 50,
            }}
          >
            tulu Ride{" "}
          </ParaOne>
        </TextWrapper>}
      </div>
      <UnitWrapper ref={roomUnitRef} items={rideColumnItems.length}>
        <RideUnits
          isPDF={isPDF}
          readOnly={true}
          itemsCount={Object.keys(items).length}
        >
          {Object.keys(items).map((key, index) => {
            const item = items[key];
            return (
              <RideUnit
                key={key}
                readOnly={true}
                rideItems={rideColumnItems}
                type={item.type}
                itemsCount={itemsCount}
                unitIdx={index}
                ride={item}
              />
            );
          })}
        </RideUnits>
      </UnitWrapper>
    </Wrapper>
  );
};

export { TuluRideExpended };

const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  @media ${device.mobileS} {
    padding-bottom: 25px;
  }
  @media ${device.tablet} {
    padding-bottom: 60px;
  }
`;

const TextWrapper = styled.div`
  //padding: 20px 0;
  flex-direction: column;
  display: flex;
  position: relative;
`;

const UnitWrapper = styled.div`
  /*  display: flex;
  justify-content: center; */
  //border: 2px solid black;

  @media ${device.mobileS} {
    //transform: scale(0.25);
    //transform-origin: top;
    //width: 200%;
  }
  @media ${device.tablet} {
    //transform: none;
    //width: 100%;
  }
`;

const ParaOne = styled.p`
  font-size: 52px;
  font-weight: bold;
  font-family: "Lexend", serif;
  margin: 0px;
  text-transform: uppercase;
  text-align: center;
  @media ${device.mobileS} {
    font-size: 20px;
    padding-bottom: 25px;
    padding-top: 14.2px;
  }
  @media ${device.tablet} {
    font-size: 50px;
    padding-bottom: 38px;

    padding-top: 38px;
  }
`;
